(function($) {
	
	$(document).ready(function() {
		
		// store filter for each group
		var filters = window["_preset_filter"] || {};

		// types
		$('.filter').on( 'click', '.filter-link', function( event ) {
			event.preventDefault();
			var $this = $(this);
			// get group key
			var $buttonGroup = $this.parents('.filter-group');
			var filterGroup = $buttonGroup.attr('data-filter-group');
			// set filter for group
			filters[filterGroup] = $this.attr('data-filter');
			// filter tiles
			filterTiles(filters);
			// update filter URLs
			updateFilterURLs(filters);
			// update url history
			history.pushState(null, null, $this.attr('href'));
		});

		// industries
		$('.filter-main').on( 'click', '.filter-link', function( event ) {
			event.preventDefault();
			var $this = $(this);
			// get group key
			var $buttonGroup = $this.parents('.filter-group');
			var filterGroup = $buttonGroup.attr('data-filter-group');
			// set current filter
			$('.filter-sub').find('.current').removeClass('current');
			$('.filter-sub .filter-link').filter('[data-filter=""]').addClass('current');
			// toggle sub filter rows
			if ($this.attr('data-filter') == '') {
				$('.filter-sub').addClass('hidden');
			} else {
				$('.filter-sub').removeClass('hidden');
			}
			// set filter for group
			filters[filterGroup] = $this.attr('data-filter');
			// reset market and application filters
			delete filters['market'];
			delete filters['application'];
			// filter filters
			filterFilters(filters);
			// filter tiles
			filterTiles(filters);
			// update filter URLs
			updateFilterURLs(filters);
			// update url history
			history.pushState(null, null, $this.attr('href'));
		});

		// markets and applications
		$('.filter-sub').on( 'click', '.filter-link', function( event ) {
			event.preventDefault();
			var $this = $(this);
			// get group key
			var $buttonGroup = $this.parents('.filter-group');
			var filterGroup = $buttonGroup.attr('data-filter-group');
			// set filter for group
			filters[filterGroup] = $this.attr('data-filter');
			// filter tiles
			filterTiles(filters);
			// update filter URLs
			updateFilterURLs(filters);
			// update url history
			history.pushState(null, null, $this.attr('href'));
		});

		// change is-checked class on buttons
		$('.filter-group').each( function( i, buttonGroup ) {
			var $buttonGroup = $( buttonGroup );
			$buttonGroup.on('click', '.filter-link', function() {
				$buttonGroup.find('.current').removeClass('current');
				$(this).addClass('current');
			});
		});
			
		function filterTiles(filters) {
			// filter products
			$('hidden .product').unwrap();
			$('.product').each(function() {
				if (!showItem(this, filters)) {
					$(this).wrap('<hidden></hidden>');
				}
			});
			// filter ads
			$('.ad.hidden').removeClass('hidden');
			$('.ad').each(function() {
				if (!showItem(this, filters)) {
					$(this).addClass('hidden');
				}
			});
			var noOfAds = $('.ad:visible').length;
			if (noOfAds > 1) {
				var chosen = $('.ad:visible').eq(Math.floor(Math.random() * noOfAds));
				$('.ad:visible').addClass('hidden');
				chosen.removeClass('hidden');
			}
		}
		
		function filterFilters(filters) {
			// show all
			$('.filter-sub hidden .filter-link').unwrap();
			// hide filtered items
			$('.filter-sub .filter-link').each(function() {
				if (!showItem(this, filters)) {
					$(this).wrap('<hidden></hidden>');
				}
			});
			// show 'all' button
			$('.filter-sub hidden .filter-link').filter('[data-filter=""]').unwrap();
		}
		
		function showItem(item, filters) {
			var show = true;
			for (var filter in filters) {
				if (filters[filter] != "" && typeof $(item).attr('data-'+filter) !== 'undefined' && $(item).filter('[data-' + filter + '~="' + filters[filter] + '"]').length == 0) {
					show = false;
				}
			}
			return show;
		}

		function updateFilterURLs(filters) {
			// get base url
			var url = [location.protocol, '//', location.host, location.pathname].join('');
			if (!$.isEmptyObject(filters)) {
				// update all sub filter links
				$('.filter-group .filter-link').each(function() {
					// clone filters
					var filterClone = $.extend(true, {}, filters);
					// get current filter group
					var filterGroup = $(this).parents('.filter-group').data('filter-group');
					// replace current item in filter clone
					filterClone[filterGroup] = $(this).data('filter');
					if (filterGroup == 'industry') {
						delete filterClone['market'];
						delete filterClone['application'];
					}
					// remove empty items
					$.each(filterClone, function(key, value){
					    if (value === "" || value === null){
					        delete filterClone[key];
					    }
					});
					// build url with query string
					$(this).attr('href', url + '?' + $.param(filterClone));
					filterClone = null;
				});
			} else {
				$(this).attr('href', url);
			}
		}

	});
	
}(jQuery));